import { Component } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { RcsMetrics, getMetricFromMap } from 'src/app/road-condition/enums/rcs-metrics.enum'
import { Layers } from 'src/app/shared/layers-config/layers'

@Component({
  selector: 'app-rc-weather-prediction',
  templateUrl: './rc-weather-prediction.component.html',
  standalone: false,
})
export class RcWeatherPredictionComponent {
  public layerIds = Layers
  public metrics = RcsMetrics
  public getMetricFromMap = getMetricFromMap
  public selectedWeatherMetric: string = ''
  public isWeatherPredictionLayerVisible: boolean | undefined

  constructor(private appState: AppStateService) {
    const layers = this.appState.getState().layers
    if (layers) {
      this.isWeatherPredictionLayerVisible = layers?.includes(Layers.WeatherPrediction.name)
    }

    const weatherMetrics = this.appState.selectMetrics(Layers.WeatherPrediction.name)
    if (weatherMetrics && weatherMetrics.length > 0) {
      this.selectedWeatherMetric = weatherMetrics[0] as RcsMetrics
    }

    this.updateQueryParameters()
  }

  setMetric(metric: string) {
    this.selectedWeatherMetric = this.selectedWeatherMetric == metric ? '' : metric
    this.isWeatherPredictionLayerVisible = this.selectedWeatherMetric === '' ? false : true
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState.selectLayers(Layers.WeatherPrediction.name, false)
    if (this.isWeatherPredictionLayerVisible) {
      layers?.push(Layers.WeatherPrediction.name)
    }

    const metrics = this.appState.selectMetrics(Layers.WeatherPrediction.name, false)
    if (this.selectedWeatherMetric) {
      metrics.push(this.selectedWeatherMetric)
    }
    this.appState.setState(AppPaths.RoadCondition, {
      layers: layers?.toString(),
      metrics: metrics?.toString(),
    })
  }
}
